import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { Toaster } from '@/components/ui/toast'
import { Suspense } from 'react'
import CustomLoader from './components/CustomLoader'
import { NetworkStatus } from './components/NetworkStatus'

function App() {
  return (
    <>
      <NetworkStatus />
      <Suspense fallback={<CustomLoader />}>
        <RouterProvider router={router} />
      </Suspense>
      <Toaster />
    </>
  )
}

export default App
